import { useMemo } from 'react';
import { useSelector } from 'react-redux';

//THE SIDEBAR IS BUILT FROM permissions/byUserType , SO THE MENU IS THE AUTHORITY ON WHAT
//A USER IS ENTITLED TO.
//THE TWO SOURCES DISAGREE ON SHAPE : THE API BUILDS CHILD PATHS AS
//CONCAT_WS('/', module, path) -> "my-workspace/data-access" , WITH NO LEADING SLASH ,
//WHILE THE ENTRIES HARDCODED IN roleSlice USE "/my-workspace/...". LEADING AND TRAILING
//SLASHES ARE THEREFORE STRIPPED FROM BOTH SIDES BEFORE COMPARING , OR NOTHING EVER MATCHES.
const normalise = (path) =>
  String(path || '')
    .trim()
    .replace(/^\/+/, '')
    .replace(/\/+$/, '')
    .toLowerCase();

const collectPaths = (items, out) => {
  (items || []).forEach((item) => {
    if (item?.path) out.push(normalise(item.path));
    if (Array.isArray(item?.children)) collectPaths(item.children, out);
  });
  return out;
};

/**
 * whether the signed in user's DYNAMIC sidebar menu contains a given path.
 * use it to gate anything that should only appear for users the backend has granted the
 * matching menu item — the menu and the feature then cannot drift apart.
 * @author Akhil E M
 * @createdAt 27-08-2026
 * @updates 27-08-2026(Akhil EM),
 * @type hook
 * @param {string} path e.g. '/my-workspace/data-access'
 * @returns {boolean}
 */
export default function useHasMenuPath(path) {
  const navConfig = useSelector((state) => state.role?.navConfig);
  const otherConfig = useSelector((state) => state.role?.otherConfig);

  return useMemo(() => {
    if (!path) return false;
    const target = normalise(path);
    if (!target) return false;
    const paths = collectPaths(navConfig, []);
    collectPaths(otherConfig, paths);
    return paths.includes(target);
  }, [navConfig, otherConfig, path]);
}
